import {loginPath} from "../lib/clinicSignIn";
import React, {useEffect, useRef, useReducer} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import ChatJournalPanel from "../components/ChatJournalPanel";
import {Flex, Box} from "@chakra-ui/react";
import {isJournalOn} from "../features/journal";

export default function JournalPage() {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const loadedRef = useRef(null);

  useEffect(() => {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  useEffect(() => {
    if (!state || !state.patient) {
      navigate(loginPath());
    } else if (!isJournalOn(state)) {
      // Not turned on for this clinic (features/journal): back to the home page.
      navigate("/", {state});
    }
  }, [state, navigate]);

  if (!isJournalOn(state)) return null;

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      <Flex
        ref={loadedRef}
        style={{opacity: 0}}
        flexDirection="column"
        flex={1}
        w="100%"
        overflow="hidden"
      >
        <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
          <ChatJournalPanel state={dashState} />
        </Box>
      </Flex>
    </Layout>
  );
}
